module.exports = __webpack_public_path__ + "img/logo.b715584f.svg";